<template>
  <button type="button" class="btn btn-outline-success me-2" @click="show = true">Edit</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Passenger</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <Passenger :passenger="passenger" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="addToPassengers()">Edit Passenger</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
import Passenger from '@/components/Form/Passenger'
export default {
  name: 'EditPassengerModal',
  components: {
    Passenger
  },
  props: ['passenger', 'passengers', 'form', 'customers'],
  data() {
    return {
      show: false,
      passengerForm: this.$inertia.form({
        customers_id: this.customers.id,
        sex: this.passenger.sex,
        given_names: this.passenger.given_names,
        surname: this.passenger.surname,
        dob: this.passenger.dob,
        nationality: this.passenger.nationality,
        passport_number: this.passenger.passport_number,
        passport_issue: this.passenger.passport_issue,
        passport_expire: this.passenger.passport_expire,
      }),
    }
  },
  methods: {
    addToPassengers() {
      this.show = false;

      this.$inertia.form(this.passenger).put(`/passengers/${this.passenger.id}`)
    }
  }
}
</script>

<style>

</style>
